import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidatorFn, AbstractControl, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, forkJoin, combineLatest, Subscription } from 'rxjs';

import { isNullOrUndefined } from 'util';
import { SupplierContactTypeGroup, Language, SupplierEntityPropertyValues, SupplierContactPropertyValue, DataWithSupplierCode, Permission, OPERATION, Supplier, SupplierBasicDetails, SupplierAddress, SupplierContact, SupplierBank, SupplierTax, SupplierEntity, SupplierPropertyValue, SupplierDocument, SupplierDocumentPropertyValues, EmailDomainPropertyValue, EmailDomain } from 'app/profile/models/supplier.model';
import { UserDetails, SupplierContactMap } from 'app/profile/models/user.model';
import { ContactsService } from 'app/profile/services/contacts.service';
import { MasterDataService } from 'app/profile/services/masterdata.service';
import { SupplierContactType, Role, Country } from 'app/profile/models/masterdata.model';
import { CustomValidator } from 'app/shared/custom-validator/custom-validator';
import { deepfind, validateAllFormFields, GetFullName, getNestedNode, extractDomainFromEmail, isNullOrEmpty, transformEmailDomain } from 'app/shared/utils/utils';
import { TslDialog, TslFileDrop } from '@tesla/ng-tds';
import { Store, select } from '@ngrx/store';
import { SupplierState } from 'app/profile/store/state/supplierstate.state';
import { GetContactRoleList, GetLanguageList, DeleteSupplierContact, EditSupplierContact, AddSupplierContact, GetSupplierProfile, GetSupplierContactListByCode, GetSupplierEntityListByCode, GetSupplierDocumentsListByCode, GetCountryList, GetEmailDomains } from 'app/profile/store/app.actions';
import { SelectContactRoles, SelectLanguages, SelectSupplierProfile, SelectSupplierContactList, SelectSupplierEntityList, getGeneralSettings, SelectSupplierDocumentList, SelectCountries, SelectEmailDomainList } from 'app/profile/store/app.selector';
import { Profile } from 'app/profile/models/profile.model';
import { I18nService } from 'app/shared/services/i18n.service';
import { GeneralSettings } from 'app/profile/models/generic.model';
import { FileUploadService } from '../../../../../../common/services/fileUpload.service';
import { BaseComponent } from 'app/profile/components/base.component';
import { AppSettings } from '../../../../../../app.settings';
import { DomainEditComponent } from 'app/common/domain/domain-edit.component';


@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent extends BaseComponent implements OnInit {
  @ViewChild('fileDrop', { static: false }) fileDrop: TslFileDrop;

  contactForm: FormGroup;
  contactTypes: Role[];
  contactTypeGroups: SupplierContactTypeGroup[];
  languages: Language[];
  countries$: Observable<Country[]>;
  entityMap: SupplierEntityPropertyValues[];
  data: SupplierContactPropertyValue;
  previousData: SupplierContactPropertyValue;
  currentContactItem: SupplierContactPropertyValue = null;
  supplierCode: string;
  currentUser: UserDetails;
  contactEamilIds: string[] = [];
  showEmailInfo: boolean = false;
  isManageContact: boolean = false;
  isPrimary: boolean;
  isProfileAdmin: boolean;
  profile: Profile = null;
  showDomainDiffSection: boolean = false;
  validDomainList: string[] = [];
  allDomains: EmailDomainPropertyValue[] = [];
  contactReasons$: Observable<string[]>;
  EmailInfo: string = "You are unable to change critical contacts email. Please contact vendorchanges@tesla.com to inquire about email changes.";
  subscription: Subscription;
  supplierContactList: SupplierContactPropertyValue[];
  contactInitialData: string = null;
  settings: GeneralSettings;
  docsList: SupplierDocumentPropertyValues[];
  showDocument: boolean = false;
  showITcontactWarning: boolean;
  isITchecked: boolean = false;
  uploadedDocs: SupplierDocumentPropertyValues[];
  isDocumentAdding: boolean = false;
  showCorrDocument: boolean = false;
  criticalContactTypes: string[] = ["primary", "finance lead", "remit to", "profile admin", "finance"];
  initialContactTypes: string[] = [];
  newCriticalContactsAdded: boolean = false;
  isReasonsCollected: boolean = false;

  get ContactformControls() {
    return {
      FirstName: this.contactForm.get('FirstName'),
      LastName: this.contactForm.get('LastName'),
      Email: this.contactForm.get('Email'),
      LanguageCode: this.contactForm.get('LanguageCode'),
      JobTitle: this.contactForm.get('JobTitle'),
      Mobile: this.contactForm.get('Mobile'),
      Phone: this.contactForm.get('Phone'),
      Fax: this.contactForm.get('Fax'),
      IsFinanceLead: this.contactForm.get('IsFinanceLead'),
      IsRemitTo: this.contactForm.get('IsRemitTo'),
      IsPrimaryContact: this.contactForm.get('IsPrimaryContact'),
      Approver: this.contactForm.get('Approver'),
      Types: this.contactForm.get('Types'),
      Comment: this.contactForm.get('Comment'),
      ITchecking: this.contactForm.get('ITchecking'),
      ResidenceCountry: this.contactForm.get('ResidenceCountry'),
      SkipResidenceCountry: this.contactForm.get('SkipResidenceCountry'),
      HasValidDomain: this.contactForm.get('HasValidDomain'),
      AddToValidDomain: this.contactForm.get('AddToValidDomain'),
      Reason: this.contactForm.get('Reason'),
      Website: this.contactForm.get('Website'),
      DomainComment: this.contactForm.get('DomainComment'),
      HasWebsite: this.contactForm.get('HasWebsite'),
      AdditionalReason: this.contactForm.get('AdditionalReason')
    }
  }
  constructor(public dialogRef: MatDialogRef<ContactFormComponent>,
    @Inject(MAT_DIALOG_DATA) public matData: DataWithSupplierCode<SupplierContactPropertyValue>,
    private fb: FormBuilder,
    private masterDataService: MasterDataService,
    private contactService: ContactsService,
    private snackBar: MatSnackBar,
    private translate: I18nService,
    private dialog: TslDialog,
    private config: AppSettings,
    private fileUploadService: FileUploadService,
    private store: Store<SupplierState>) {
    super();
    this.subscription = new Subscription();
  }

  ngOnInit() {
    this.initializeData();
    this.contactReasons$ = this.masterDataService.getEmailDomainContactReasons()
      .map(y => {
        if (y) {
          return y;
        }
      })

    // Get all contact types
    if (this.data) {
      this.contactForm = this.fb.group({
        FirstName: [{
          value: this.data.firstName.newValue ? this.data.firstName.newValue : null,
          disabled: this.data.firstName.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.firstName.permission)
        }, [Validators.required, CustomValidator.noWhitespaceValidator, Validators.pattern("^([a-zA-Z\\s]+)$")]],
        LastName: [{
          value: this.data.lastName.newValue ? this.data.lastName.newValue : null,
          disabled: this.data.lastName.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.lastName.permission)
        }, [Validators.required, CustomValidator.noWhitespaceValidator, Validators.pattern("^([a-zA-Z\\s]+)$")]],
        Email: [{
          value: this.data.email.newValue ? this.data.email.newValue : null,
          disabled: this.data.email.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.email.permission)
        }, [Validators.required, Validators.email]],
        LanguageCode: [{
          value: this.data.languageCode.newValue ? this.data.languageCode.newValue : null,
          disabled: this.data.email.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.email.permission)
        }, [Validators.required]],
        JobTitle: [{
          value: this.data.jobTitle.newValue ? this.data.jobTitle.newValue : null,
          disabled: this.data.jobTitle.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.jobTitle.permission)
        }, [Validators.required, CustomValidator.noWhitespaceValidator]],
        Mobile: [{
          value: this.data.mobile.newValue ? this.data.mobile.newValue : null,
          disabled: this.data.mobile.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.mobile.permission)
        }],
        Phone: [{
          value: this.data.phone.newValue ? this.data.phone.newValue : null,
          disabled: this.data.phone.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.phone.permission)
        }, [Validators.required, CustomValidator.noWhitespaceValidator]],
        Fax: [{
          value: this.data.fax.newValue ? this.data.fax.newValue : null,
          disabled: this.data.fax.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.fax.permission)
        }],
        ITchecking: [{
          value: this.data.iTchecking?.newValue ? this.data.iTchecking?.newValue : null,
          disabled: (this.data.types.permission !== Permission.ReadWrite &&
            !isNullOrUndefined(this.data.types.permission))
        }],

        Types: [{
          value: this.data.types.newValue ? this.data.types.newValue : null,
          disabled: this.data.types.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.types.permission)
        }, Validators.required],

        ResidenceCountry: [{
          value: this.data.residenceCountry?.newValue ? this.data.residenceCountry.newValue : null,
          disabled: this.data.residenceCountry?.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.residenceCountry?.permission)
        }, this.data.skipResidenceCountry?.newValue ? null : Validators.required],

        SkipResidenceCountry: [{
          value: this.data.skipResidenceCountry?.newValue ? this.data.skipResidenceCountry?.newValue : false,
          disabled: this.data.skipResidenceCountry?.permission !== Permission.ReadWrite && !isNullOrUndefined(this.data.skipResidenceCountry?.permission)
        }],

        Comment: [{
          value: this.data.comment.newValue ? this.data.comment.newValue : null,
          disabled: false
        }, [Validators.pattern("^([a-zA-Z\\s.,-_!%$()#+]+)$")]],
        HasValidDomain: [{
          value: this.matData.data.hasValidDomain?.newValue ? this.matData.data.hasValidDomain?.newValue : null,
          disabled: (this.matData.data.hasValidDomain?.permission !== Permission.ReadWrite &&
            !isNullOrUndefined(this.matData.data.hasValidDomain?.permission))
        }],
        AddToValidDomain: [{
          value: this.matData.data.addToValidDomain?.newValue ? this.matData.data.addToValidDomain?.newValue : null,
          disabled: (this.matData.data.addToValidDomain?.permission !== Permission.ReadWrite &&
            !isNullOrUndefined(this.matData.data.addToValidDomain?.permission))
        }],
        Reason: [{
          value: this.matData.data.reason?.newValue ? this.matData.data.reason?.newValue : null,
          disabled: (this.matData.data.reason?.permission !== Permission.ReadWrite &&
            !isNullOrUndefined(this.matData.data.reason?.permission))
        }],
        Website: [{
          value: this.matData.data.website?.newValue ? this.matData.data.website?.newValue : null,
          disabled: (this.matData.data.website?.permission !== Permission.ReadWrite &&
            !isNullOrUndefined(this.matData.data.website?.permission))
        }],
        DomainComment: [{
          value: this.matData.data.domainComment?.newValue ? this.matData.data.domainComment?.newValue : null,
          disabled: (this.matData.data.domainComment?.permission !== Permission.ReadWrite &&
            !isNullOrUndefined(this.matData.data.domainComment?.permission))
        }],
        HasWebsite: [{
          value: this.matData.data.website?.newValue?.length > 0 ? "Yes" : "No"
        }],
        AdditionalReason: [{
          value: this.matData.data.additionalReason?.newValue ? this.matData.data.additionalReason?.newValue : null,
          disabled: (this.matData.data.additionalReason?.permission !== Permission.ReadWrite &&
            !isNullOrUndefined(this.matData.data.additionalReason?.permission))
        }],
      }, { emitEvent: false });

      if (this.data.skipResidenceCountry?.newValue) {
        this.contactForm.get('ResidenceCountry').disable();
      }
      if (this.data.types.newValue && this.data.types.newValue.find(x => x.toLowerCase() === 'primary') || this.data.types.newValue.find(x => x.toLowerCase() === 'remit to') || this.data.types.newValue.find(x => x.toLowerCase() === 'finance lead') || this.data.types.newValue.find(x => x.toLowerCase() === 'portal account')) {
        this.contactForm.get('Email').disable();
        this.showEmailInfo = true;
      }

      if(this.data?.types?.newValue && this.data?.types?.newValue?.length > 0){
        this.initialContactTypes = this.data?.types?.newValue;
      }

      if(this.data?.addToValidDomain?.newValue?.length > 0){
        this.isReasonsCollected = true;
        this.newCriticalContactsAdded = true;
      }
    } else {
      this.contactForm = this.fb.group({
        FirstName: [null, [Validators.required, CustomValidator.noWhitespaceValidator, Validators.pattern("^([a-zA-Z\\s]+)$")]],
        LastName: [null, [Validators.required, CustomValidator.noWhitespaceValidator, Validators.pattern("^([a-zA-Z\\s]+)$")]],
        Email: [null, [Validators.required, Validators.email]],
        LanguageCode: [null, Validators.required],
        JobTitle: [null, [Validators.required, CustomValidator.noWhitespaceValidator]],
        Mobile: [null, Validators.pattern(/^[\d\w #()+-]+$/)],
        Phone: [null, [Validators.required, CustomValidator.noWhitespaceValidator, Validators.pattern(/^[\d\w #()+-]+$/)]],
        Fax: [null, Validators.pattern(/^[\d\w #()+-]+$/)],
        Types: [null, Validators.required],
        Comment: [null, [Validators.pattern("^([a-zA-Z\\s.,-_!%$()#+]+)$")]],
        ResidenceCountry: [null, Validators.required],
        SkipResidenceCountry: [null],
        ITchecking: [null],
        HasValidDomain: [null],
        AddToValidDomain: [null],
        Reason: [null],
        Website: [null],
        DomainComment: [null],
        AdditionalReason: [null],
        HasWebsite: [null],
      });
    }

    this.bindDocumentForm();
    this.toShowITContactWarning();

    this.contactForm.get('SkipResidenceCountry').valueChanges.subscribe(res => {
      if (res) {
        this.contactForm.get('ResidenceCountry').setValue(null, { emitEvent: false });
        this.contactForm.get('ResidenceCountry').clearValidators();
        this.contactForm.get('ResidenceCountry').updateValueAndValidity();
        this.contactForm.get('ResidenceCountry').disable();
      } else {
        this.contactForm.get('ResidenceCountry').setValidators([Validators.required]);
        this.contactForm.get('ResidenceCountry').updateValueAndValidity();
        this.contactForm.get('ResidenceCountry').enable();
      }
    })

    const financeLead = this.contactForm.get('Types').valueChanges.subscribe((items: string[]) => {
      if (items) {
        if (items.find(x => x == 'Primary' || x == 'Profile Admin' || x == 'Environment, Health and Safety') && !items.find(x => x == 'Portal Account')) {
          items.push('Portal Account');
        }

        if (items.find(x => x == 'Finance Lead' || x == "Remit To") && !items.find(x => x == 'Finance')) {
          items.push('Finance');
        }

        this.contactForm.get('Types').setValue(items, { emitEvent: false });
      }

      this.bindDocumentForm(true);
      this.toShowITContactWarning();

      this.setIsCriticalContactAddedFlag();
      this.setDomainDifFields(this.contactForm?.get('Email')?.value);
    });

    // set email validators
    if (this.isPrimary) {
      this.ContactformControls.Email.clearValidators();
      this.ContactformControls.Email.setValidators([Validators.required, Validators.email])
      this.ContactformControls.Email.updateValueAndValidity();
    } else {
      this.ContactformControls.Email.clearValidators();
      this.ContactformControls.Email.setValidators([Validators.required, Validators.email, this.validEmailDomainValidator(this.validDomainList)])
      this.ContactformControls.Email.updateValueAndValidity();
    }

    this.contactForm.get('HasValidDomain').valueChanges.subscribe(res => {
      this.setHasDomainValidDomainFieldsAndValidators();
    });

    this.contactForm.get('AddToValidDomain').valueChanges.subscribe(res => {
      this.setAddToValidDomainFields(res);
    });

    this.contactForm.get('Reason').valueChanges.subscribe(res => {
      this.setAdditionalReasonFields(res);
    });

    this.contactForm.get('HasWebsite').valueChanges.subscribe(res => {
      this.setHasWebsiteFields(res);
    });

    this.contactForm.patchValue({
      Types: deepfind(this.data && this.data.types, 'newValue') || ["Portal Account"]
    }, { emitEvent: true });

    this.contactInitialData = JSON.stringify(this.contactForm.value);
  }

  initializeData(): void {
    this.data = JSON.parse(JSON.stringify(this.matData.data));
    if (this.data) {
      this.currentContactItem = this.matData.data;
    }
    this.supplierCode = this.matData.suppliercode;
    this.currentUser = this.matData.currentUser;
    this.isManageContact = this.matData.isManageContact;
    this.store.dispatch(new GetContactRoleList());
    this.store.dispatch(new GetCountryList());
    this.store.select(getGeneralSettings).subscribe(res => this.settings = res);
    this.store.dispatch(new GetLanguageList());
    this.store.dispatch(new GetSupplierProfile(this.supplierCode));
    this.store.dispatch(new GetSupplierDocumentsListByCode(this.supplierCode));
    this.store.dispatch(new GetEmailDomains(this.supplierCode, false));

    this.countries$ = this.store.select(SelectCountries);
    this.store.select(SelectEmailDomainList)
      .subscribe(items => {
        if (items) {
          this.allDomains = new Array(...items);
          let approvedDomains = this.allDomains?.filter(x => x.operation == null || isNullOrUndefined(x.operation?.newValue) || isNullOrEmpty(x.operation?.newValue));
          if (approvedDomains && approvedDomains.length > 0) {
            this.validDomainList = approvedDomains?.filter(x => x.domain?.newValue?.length > 0)?.map(x => x.domain?.newValue);
          } else {
            this.validDomainList = [];
          }
        }
      });

    if (this.currentUser.supplierContact && this.currentUser.supplierContact.supplierMaps) {
      const supplierMap: SupplierContactMap = this.currentUser.supplierContact.supplierMaps.find(x => x.supplierCode == this.supplierCode) as SupplierContactMap;
      this.isPrimary = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "primary");
      this.isProfileAdmin = supplierMap.userRoles.some(x => x.role.toLocaleLowerCase() === "profile admin");
    }

    const supplierProfile = this.store.pipe(select(SelectSupplierProfile)).subscribe(res => {
      if (res) {
        this.profile = res;
      }
    });

    this.store.dispatch(new GetSupplierContactListByCode(this.supplierCode, false));
    this.store.dispatch(new GetSupplierEntityListByCode(this.supplierCode, false));

    var supplierSub = combineLatest(
      [this.store.pipe(select(SelectSupplierContactList)),
      this.store.pipe(select(SelectSupplierEntityList))]).subscribe(([supplierContactResult, supplierEntityResult]) => {
        if (supplierContactResult && supplierEntityResult) {
          this.entityMap = supplierEntityResult;
          this.supplierContactList = new Array(...supplierContactResult);
        }
      }, err => {
        console.error(`Service call error: GetSupplierContactListByCode or getEntityListByCode. Details: ` + err);
      });
    this.subscription.add(supplierSub);

    this.store.select(SelectSupplierDocumentList).subscribe(docsList => {
      if (docsList && docsList.length > 0) {
        this.docsList = new Array(...docsList);
      }
    });

    combineLatest(
      [this.store.pipe(select(SelectContactRoles)),
      this.store.pipe(select(SelectLanguages))]).subscribe(([contactRoles, supplierLanguages]) => {
        if (contactRoles && supplierLanguages) {
          this.languages = supplierLanguages.sort((a, b) => {
            return a.name.localeCompare(b.name);
          });

          this.contactTypes = contactRoles.filter(x => x.isSystemRole === false);
          this.contactTypeGroups = [{
            Name: 'Critical',
            Types: this.contactTypes.filter(x => x.isCritical === true).sort((a, b) => {
              return a.id.localeCompare(b.id);
            })
          },
          {
            Name: 'General',
            Types: this.contactTypes.filter(x => x.isCritical !== true).sort((a, b) => {
              return a.id.localeCompare(b.id);
            })
          }];
        }
      }, err => {
        console.error(`Service call error: GetSupplierContactTypes or GetLanguages. Details: ` + err);
      });
  }

  setIsCriticalContactAddedFlag(){
    if(this.isReasonsCollected){
        this.newCriticalContactsAdded = true;
        return;
    }
    var selectedContactTypes = this.contactForm.get("Types").value;
    this.newCriticalContactsAdded = false;
    if(selectedContactTypes && selectedContactTypes?.length > 0){
        selectedContactTypes.forEach(c => {
            if(this.initialContactTypes && this.initialContactTypes?.length > 0 && this.initialContactTypes.find(x => x.toLocaleLowerCase() == c.toLocaleLowerCase()) != undefined){
                // do nothing
            }else{
                if(this.criticalContactTypes.find(x => x.toLocaleLowerCase() == c.toLocaleLowerCase())){
                    this.newCriticalContactsAdded = true;
                }
            }
        });
    }
}

  close(): void {
    this.dialogRef.close();
  }

  setDomainFields(){
    if(this.isPrimary == true){
      let email = this.contactForm.get('Email').value;
      this.setDomainDifFields(email);
    }
  }

  save() {
    if (this.contactForm.valid && ((this.showITcontactWarning && this.isITchecked) || (!this.showITcontactWarning))) {
      var isNewContactFrom = this.data === null;
      this.data = this.data ? { ...this.data } : new SupplierContactPropertyValue();
      if (this.contactInitialData == JSON.stringify(this.contactForm.value)) {
        this.dialog.alert(this.translate.get('Error'), this.translate.get('No changes to submit!'));
        return;
      }
      if (!this.contactForm.get('Email').pristine) {

        // If email is changed then send new and old both dataitem.
        if (!isNewContactFrom && this.data.email.newValue !== this.contactForm.get('Email').value) {
          this.previousData = JSON.parse(JSON.stringify(this.data));
        }
        this.data.email.newValue = this.contactForm.get('Email').value;
        if (this.contactService.supplierContactItems) {
          this.contactService.supplierContactItems.filter(x => x.isTouched != true).forEach(x => {
            this.contactEamilIds.push(x.email.newValue);
          });
        }
      }
      if (!this.contactForm.get('FirstName').pristine) {
        this.data.firstName.newValue = this.contactForm.get('FirstName').value.trim();
      }
      if (!this.contactForm.get('LastName').pristine) {
        this.data.lastName.newValue = this.contactForm.get('LastName').value.trim();
      }
      if (!this.contactForm.get('JobTitle').pristine) {
        this.data.jobTitle.newValue = this.contactForm.get('JobTitle').value;
      }
      if (!this.contactForm.get('Mobile').pristine) {
        let value: string = this.contactForm.get('Mobile').value;
        if (value && value.length > 0) {
          this.data.mobile.newValue = value;
        }
      }
      if (!this.contactForm.get('Phone').pristine) {
        this.data.phone.newValue = this.contactForm.get('Phone').value;
      }
      if (!this.contactForm.get('Fax').pristine) {
        let value: string = this.contactForm.get('Fax').value;
        if (value && value.length > 0) {
          this.data.fax.newValue = value;
        }
      }
      if (!this.contactForm.get('ITchecking').pristine) {
        this.data.iTchecking.newValue = this.contactForm.get('ITchecking').value;
      }

      if (!this.contactForm.get('LanguageCode').pristine) {
        this.data.languageCode.newValue = this.contactForm.get('LanguageCode').value;
      }
      if (!this.contactForm.get('Types').pristine) {
        this.data.types.newValue = this.contactForm.get('Types').value;
      }
      if (!this.contactForm.get('ResidenceCountry').pristine) {
        this.data.residenceCountry.newValue = this.contactForm.get('ResidenceCountry').value;
      }
      if (!this.contactForm.get('SkipResidenceCountry').pristine) {
        this.data.skipResidenceCountry.newValue = this.contactForm.get('SkipResidenceCountry').value;
      }
      if (!this.contactForm.get('Comment').pristine) {
        this.data.comment.newValue = this.contactForm.get('Comment').value;
      }

      if (!this.contactForm.get('AddToValidDomain').pristine) {
        this.data.addToValidDomain.newValue = this.contactForm.get('AddToValidDomain').value;
      }
      if (!this.contactForm.get('Reason').pristine) {
        this.data.reason.newValue = this.contactForm.get('Reason').value;
      }
      if (!this.contactForm.get('Website').pristine) {
        this.data.website.newValue = this.contactForm.get('Website').value;
      }
      if (!this.contactForm.get('DomainComment').pristine) {
        this.data.domainComment.newValue = this.contactForm.get('DomainComment').value;
      }
      if (!this.contactForm.get('AdditionalReason').pristine) {
        this.data.additionalReason.newValue = this.contactForm.get('AdditionalReason').value;
      }
      if (!this.contactForm.get('HasValidDomain').pristine) {
        this.data.hasValidDomain.newValue = this.contactForm.get('HasValidDomain').value;
      }

      if (this.showDocument && !this.isPCFUploaded && (!this.documents || this.documents.length == 0)) {
        this.dialog.alert(this.translate.get('Alert'), this.translate.get('Please upload a document!'));
        return;
      }

      if (this.contactEamilIds.findIndex(item => this.data.email.newValue.toLowerCase() === item.toLowerCase()) >= 0) {
        this.dialog.alert(this.translate.get('Error'), this.translate.get('Email Id already exists. Try again with a different email.'));
        this.dialogRef.close();
      }
      else {
        if ((this.showDocument || this.showCorrDocument)
          && this.documents
          && this.documents.length > 0
          && this.documents.controls.filter(d => !d.get('documentId').value)
          && this.documents.controls.filter(d => !d.get('documentId').value).length > 0) {
          let files = this.documents.controls.filter(d => !d.get('documentId').value).map(x => x.get('attachment').value) as File[];
          this.fileUploadService.uploadFilesToServer(files, this.supplierCode).subscribe(docs => {
            if (docs) {
              this.uploadedDocs = [];
              docs.forEach(doc => {
                const document = new SupplierDocumentPropertyValues();
                document.operation.newValue = OPERATION.CREATE;
                document.documentID.newValue = doc.documentID;
                document.documentType.newValue = this.documents.controls.find(d => !d.get('documentId').value && d.get("fileName").value == doc.fileName)?.get('documentType')?.value ?? "PCF";
                document.fileName.newValue = doc.fileName;
                document.documentVersion.newValue = doc.documentVersion;
                document.referenceSystem.newValue = 'DMS';
                document.effectiveDate.newValue = new Date();
                this.uploadedDocs.push(document);
              });

              this.data.documents.newValue = this.uploadedDocs.map(doc => {
                return doc.documentID.newValue;
              });

              let contactData = [this.data];
              if (this.previousData) {
                contactData.push(this.previousData);
              }
              this.UpdateContactItem(this.currentContactItem, contactData);
            }
          });
        }
        else {
          let contactData = [this.data];
          if (this.previousData) {
            contactData.push(this.previousData);
          }
          this.UpdateContactItem(this.currentContactItem, contactData);
        }
      }
    } else {
      validateAllFormFields(this.contactForm);
    }
  }

  UpdateContactItem(dataItem, x: SupplierContactPropertyValue[]) {
    let supplierContact: SupplierContactPropertyValue = null;
    if (x) {
      if (x.length === 1) {
        supplierContact = x[0];
      }
      else if (x.length === 2) {
        var oldItem = x[1];
        var newItem = x[0];
        supplierContact = newItem;
        var dataItemCopy = dataItem;
        if ((deepfind(supplierContact.types, 'newValue').indexOf('Portal Account') == -1 && !dataItem) ||
          (deepfind(supplierContact.types, 'newValue').indexOf('Portal Account') == -1 &&
            dataItem)) {
          if (dataItem && dataItem.id) {
            this.store.dispatch(new DeleteSupplierContact(this.supplierContactList.indexOf(oldItem)));
          }
        }
        dataItem = null;
      }
      if (supplierContact.types.newValue === undefined) {
        supplierContact.types.newValue = [];
        supplierContact.types.newValue.push('Portal Account');
      }
      if ((deepfind(supplierContact.types, 'newValue').indexOf('Portal Account') > -1 && !dataItem) ||
        (deepfind(supplierContact.types, 'newValue').indexOf('Portal Account') > -1 &&
          dataItem &&
          deepfind(dataItem.types, 'newValue').indexOf('Portal Account') == -1)) {
        var portalAccountconfirmation = this.dialog.confirm(this.translate.get('Confirm'), this.translate.get('Contacts are provided different access in the Supplier Portal depending on their Supplier Purpose Category selected in the Portal. This contact will get access to the Portal based on the current purpose selections. If you need to change this, edit the Supplier Purpose Categories selected in Manage Contacts before you submit.'));
        portalAccountconfirmation.afterClosed().subscribe(confirm => {
          if (confirm) {
            if (dataItem == null && dataItemCopy && dataItemCopy.id) {
              this.store.dispatch(new DeleteSupplierContact(this.supplierContactList.indexOf(oldItem)));
            }
            this.CheckForPrimaryAndProcessContact(dataItem, supplierContact);
          }
        });
      } else {
        this.CheckForPrimaryAndProcessContact(dataItem, supplierContact);
      }
    }
  }

  CheckForPrimaryAndProcessContact(dataItem, x: SupplierContactPropertyValue) {
    var currentPrimaryUser = this.supplierContactList.find(y => deepfind(y.types, 'newValue').indexOf('Primary') > -1);
    var currentFinanceLeadUser = this.supplierContactList.find(y => deepfind(y.types, 'newValue').indexOf('Finance Lead') > -1);
    var currentRemitToUsers = this.supplierContactList.filter(y => deepfind(y.types, 'newValue').indexOf('Remit To') > -1);
    var options = [];

    if (currentRemitToUsers && currentRemitToUsers.length === 1 && currentRemitToUsers[0].email.newValue === deepfind(dataItem, 'email.newValue') &&
      (deepfind(dataItem, 'types.newValue') && dataItem.types.newValue.some(t => t.toLowerCase() === 'remit to')) &&
      (deepfind(x, 'types.newValue') && !x.types.newValue.some(t => t.toLowerCase() === 'remit to'))) {
      this.dialog.alert(this.translate.get('Error'), this.translate.get('There should be at least one Remit To Contact'));
      return;
    }

    if (currentPrimaryUser && currentPrimaryUser.email.newValue != deepfind(dataItem, 'email.newValue') && deepfind(x, 'types.newValue').indexOf('Primary') > -1) {
      options.push(`Primary user will be changed from ${GetFullName(currentPrimaryUser, 'newValue')} to ${GetFullName(x, 'newValue')}`);
    }

    if (currentFinanceLeadUser && currentFinanceLeadUser.email.newValue != deepfind(dataItem, 'email.newValue') && deepfind(x, 'types.newValue') && deepfind(x, 'types.newValue').indexOf('Finance Lead') > -1) {
      options.push(`Finance lead will be changed from ${GetFullName(currentFinanceLeadUser, 'newValue')} to ${GetFullName(x, 'newValue')}`);
    }

    if (options.length > 0) {
      var primaryConfirmation = this.dialog.confirm(this.translate.get('Confirm'), this.translate.get('Changes occurred') + ' ' + options.join(','));

      primaryConfirmation.afterClosed().subscribe(confirmation => {
        if (confirmation) {
          this.processContactUpdate(dataItem, x);
          if (currentPrimaryUser && currentPrimaryUser.email.newValue != deepfind(dataItem, 'email.newValue') && deepfind(x.types, 'newValue').indexOf('Primary') > -1) {
            currentPrimaryUser.operation.newValue = OPERATION.UPDATE;
            currentPrimaryUser.types.newValue = currentPrimaryUser.types.newValue.filter(c => c.toLowerCase() !== "primary");
            this.processContactUpdate(currentPrimaryUser, currentPrimaryUser);
            this.submit();
          }

          if (currentFinanceLeadUser && currentFinanceLeadUser.email.newValue != deepfind(dataItem, 'email.newValue') && deepfind(x, 'types.newValue') && deepfind(x, 'types.newValue').indexOf('Finance Lead') > -1) {
            currentFinanceLeadUser.operation.newValue = OPERATION.UPDATE;
            currentFinanceLeadUser.types.newValue = currentFinanceLeadUser.types.newValue.filter(c => c.toLowerCase() !== "finance lead");
            this.processContactUpdate(currentFinanceLeadUser, currentFinanceLeadUser);
            this.submit();
          }
        }
      });
    } else {
      this.processContactUpdate(dataItem, x);
      this.submit();
    }
  }

  processContactUpdate(selectedContact: SupplierContactPropertyValue, existingContact: SupplierContactPropertyValue) {
    if (selectedContact) {
      const selectedContactIndex = this.supplierContactList.findIndex(c => c && c.email && c.email.newValue && selectedContact.email && selectedContact.email.newValue && c.email.newValue.toLocaleLowerCase() == selectedContact.email.newValue.toLocaleLowerCase());
      if (selectedContactIndex >= 0) {
        if (selectedContact.id) {
          existingContact.operation.newValue = OPERATION.UPDATE;
        }
        this.store.dispatch(new EditSupplierContact({
          index: selectedContactIndex,
          data: existingContact
        }));
      }
    } else {
      this.store.dispatch(new AddSupplierContact(existingContact));
    }
  }

  submit() {
    var supplier = new SupplierPropertyValue();
    supplier.contacts = this.supplierContactList;
    if (this.supplierCode && supplier.contacts.filter(x => x.isTouched).length > 0) {
      supplier.contacts = supplier.contacts.filter(x => x.isTouched);
      var supplierDetails = this.pickNewValues(supplier);
      var supplierCategory = this.profile.supplierDetails.supplierCategory;

      if (supplierDetails.Contacts && supplierDetails.Contacts.length > 0) {
        supplierDetails.Contacts.forEach(x => {
          if (x.ID === null) {
            x.ID = 0;
          }
        });
      }

      if (supplierCategory.some(x => x.name.toLowerCase() === 'direct') && this.directSupplier(this.supplierContactList) === false) {
        this.dialog.alert(this.translate.get('Error'), this.translate.get('There should be at least one material planning contact!'));
      }
      else {
        this.dialogRef.close(supplierDetails);
      }
    } else {
      this.dialog.alert(this.translate.get('Error'), this.translate.get('No changes to submit!'));
    }
  }

  pickNewValues(supplierData: SupplierPropertyValue): Supplier {
    if (!supplierData) {
      return null;
    }
    const supplier = new Supplier();

    if (supplierData.contacts) {
      supplier.Contacts = [];
      supplierData.contacts.forEach((contact, index) => {
        supplier.Contacts[index] = new SupplierContact();
        Object.keys(contact).forEach(name => {
          supplier.Contacts[index][name] = getNestedNode([name, 'newValue'], contact);
        });
        supplier.Contacts[index].Operation = contact.operation.newValue ? contact.operation.newValue : null;
      });
    }

    if (supplierData.entities) {
      supplier.Entities = [];
      supplierData.entities.forEach((document, index) => {
        supplier.Entities[index] = new SupplierEntity();
        Object.keys(document).forEach(name => {
          supplier.Entities[index][name] = getNestedNode([name, 'newValue'], document);
        });
        supplier.Entities[index].Operation = document.operation.newValue ? document.operation.newValue : null;
      });
    }

    if (this.uploadedDocs) {
      supplier.Documents = [];
      this.uploadedDocs.forEach((document, index) => {
        supplier.Documents[index] = new SupplierDocument();
        Object.keys(document).forEach(name => {
          supplier.Documents[index][name] = getNestedNode([name, 'newValue'], document);
        });
        supplier.Documents[index].Operation = document.operation.newValue ? document.operation.newValue : null;
      });
    }

    return supplier;
  }

  directSupplier(dataItem: SupplierContactPropertyValue[]): boolean {
    var result = false;
    dataItem.forEach(x => {
      if (x.types.newValue.includes('Material Planning')) {
        result = true;
      }
    });
    return result;
  }

  //Raise success or failure message maximum height and width
  ShowMessage(title: string, message: string) {
    this.translate.getAsync(message).subscribe((x: string) => {
      this.snackBar.open(x, '', {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['blue-snackbar']
      });
    });
  }

  ShowError(title: string, message: string) {
    this.translate.getAsync(message).subscribe((x: string) => {
      this.snackBar.open(x, '', {
        duration: 5000,
        verticalPosition: 'top',
        panelClass: ['red-snackbar']
      });
    });
  }

  setDomainDifFields(res: string) {
    let isExistingContact = this.data?.id?.newValue?.toString()?.length > 0 && this.data?.id?.newValue > 0 ? this.matData.data?.email?.newValue?.toLocaleLowerCase() == res?.toLocaleLowerCase() ? true : false : false;
        if (res && (!isExistingContact || this.newCriticalContactsAdded)) {
            var emailDomain = extractDomainFromEmail(res);
            if (emailDomain != null && ((this.validDomainList == null || this.validDomainList.length == 0) || (this.validDomainList?.length > 0 && this.validDomainList?.filter(x => x.toLocaleLowerCase() == "@" + emailDomain.toLocaleLowerCase()).length == 0))) {
                this.showDomainDiffSection = true;
            } else {
                this.showDomainDiffSection = false;
            }
        } else {
            this.showDomainDiffSection = false;
        }

        this.setHasValidDomainValidator();
  }

  setAddToValidDomainFields(addToValidDomainValue: string) {
    this.ContactformControls.Reason.clearValidators();
    this.ContactformControls.HasWebsite.clearValidators();
    this.ContactformControls.DomainComment.clearValidators();
    if (addToValidDomainValue == "Yes" || addToValidDomainValue == null) {
      this.ContactformControls.Reason.setValue(null);
      this.ContactformControls.HasWebsite.setValue(null);
      this.ContactformControls.DomainComment.setValue(null);
      this.showCorrDocument = false;
    }
    if (addToValidDomainValue == "No") {
      this.ContactformControls.Reason.setValidators([Validators.required]);
      this.ContactformControls.HasWebsite.setValidators([Validators.required]);
      this.ContactformControls.DomainComment.setValidators([Validators.required, Validators.min(50)]);
      this.showCorrDocument = true;
    }

    this.ContactformControls.Reason.updateValueAndValidity();
    this.ContactformControls.HasWebsite.updateValueAndValidity();
    this.ContactformControls.DomainComment.updateValueAndValidity();
  }

  setAdditionalReasonFields(value: string) {
    this.ContactformControls.AdditionalReason.clearValidators();
    if (value == "Other") {
      this.ContactformControls.AdditionalReason.setValidators([Validators.required]);
    } else {
      this.ContactformControls.AdditionalReason.setValue(null);
    }

    this.ContactformControls.AdditionalReason.updateValueAndValidity();
  }

  setHasWebsiteFields(value: string) {
    this.ContactformControls.Website.clearValidators();
    if (value == "Yes") {
      this.ContactformControls.Website.setValidators([Validators.required]);
    } else {
      this.ContactformControls.Website.setValue(null);
    }

    this.ContactformControls.Website.updateValueAndValidity();
  }

  // set has valid domain validators
  setHasValidDomainValidator() {
    this.ContactformControls.HasValidDomain.clearValidators();
    if (this.showDomainDiffSection) {
      this.ContactformControls.HasValidDomain.setValidators([Validators.required]);
    } else {
      this.ContactformControls.HasValidDomain.setValue(null);
    }
    this.ContactformControls.HasValidDomain.updateValueAndValidity();

    //check if email domain field is 
    if(this.showDomainDiffSection){
      if(this.contactForm?.get("Email")?.disabled || this.validDomainList == null || this.validDomainList.length == 0){
          this.ContactformControls.HasValidDomain.setValue("No");
          this.ContactformControls.HasValidDomain.updateValueAndValidity();
          this.ContactformControls.HasValidDomain.disable();
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isFieldValid(field: string) {
    return !this.contactForm.get(field).valid && this.contactForm.get(field).touched;
  }
  displayFieldCss(field: string) {
    return {
      'is-error': this.isFieldValid(field),
      'required': this.contactForm.get(field).validator
    };
  }

  disableContactType(type: Role) {
    if (this.data && this.entityMap) {
      if ((type.id.toLowerCase() === 'portal account' && deepfind(this.data, 'types.newValue') && this.data.types.newValue.find(x => x.toLowerCase() === 'portal account')) || (
        (this.entityMap.findIndex(x => deepfind(x.contactID, 'newValue') && ((deepfind(x.contactID, 'newValue') === deepfind(this.data && this.data.id, 'newValue') ||
          deepfind(x.contactID, 'newValue') === deepfind(this.data && this.data.stageID, 'newValue')))) > -1) &&
        (type.id.toLowerCase() === 'finance' && deepfind(this.data, 'types.newValue') && this.data.types.newValue.find(x => x.toLowerCase() === 'finance')))) {
        return true;
      }
    }
    if (this.isProfileAdmin === true && this.isPrimary !== true) {
      return type.isCritical === true;
    }

    if (this.isPrimary === true) {
      if ((type.id.toLowerCase() === 'primary' && deepfind(this.data, 'types.newValue') && this.data.types.newValue.find(x => x.toLowerCase() === 'primary')) ||
        (type.id.toLowerCase() === 'finance lead' && deepfind(this.data, 'types.newValue') && this.data.types.newValue.find(x => x.toLowerCase() === 'finance lead'))) {
        return true;
      }
    }

    if (this.data) {
      if (type.id.toLowerCase() === 'portal account' && deepfind(this.data, 'types.newValue') && this.data.types.newValue.find(x => x.toLowerCase() === 'portal account')) {
        return true;
      }
    }

    if (this.isManageContact === false) {
      if (type.id.toLowerCase().includes('primary')) {
        return true;
      }
    }
    return false;
  }

  getCategoryTooltip(val): string {
    if (val.toLowerCase() === 'profile admin') {
      return "Supplier Profile Admin has access to add secondary contacts for your organization’s use."
    }
    else {
      return "";
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onFileAdd(event, docType: string): void {
    let file = event[0];
    if (file) {
      if (file.size > this.fileSizeLimitMB) {
        this.dialog.alert(this.translate.get('Alert'), this.translate.get('File size can not be more than 10MB!'));
      }
      else {
        const attachment = new SupplierDocument();
        const reader = new FileReader();
        reader.readAsDataURL(file);
        let documentGroup = this.getDocumentGroup(new SupplierDocumentPropertyValues());
        documentGroup.patchValue({ attachment: file, fileName: file.name, documentType: docType });
        documentGroup.setValidators(Validators.required);
        documentGroup.updateValueAndValidity();
        if (!this.documents) {
          this.contactForm.setControl('documents', this.fb.array([documentGroup]));
        }
        else {
          this.documents.push(documentGroup);
        }
      }
    }
    this.isDocumentAdding = false;
  }

  removeFile(index) {
    this.fileDrop.reset(true);
    if (this.documents) {
      this.documents.removeAt(index);
    }
  }

  onDocumentAdding() {
    this.isDocumentAdding = true;
  }

  get fileSizeLimitMB() { return this.settings.fileSizeLimitMB * 1000000; }

  isShowDocument() {
    if (this.contactForm.get('Types').value &&
      this.contactForm.get('Types').value.find(x => x.toLowerCase() === 'primary')) {
      this.showDocument = true;
    }
    else {
      this.showDocument = false;
    }
  }

  bindDocumentForm(typeChanged: boolean = false) {
    this.isShowDocument();

    if (this.showDocument) {
      if (this.data && this.data.types && this.data.types.newValue.find(x => x.toLowerCase() === 'primary')) {
        let documents: SupplierDocument[] = [];
        if (this.data.documents.newValue && this.data.documents.newValue.length > 0 && this.docsList && this.docsList.length > 0) {
          let contactDocList = this.docsList.filter(x => this.data.documents.newValue && this.data.documents.newValue.includes(x.documentID.newValue));
          contactDocList.forEach(x => {
            if (!isNullOrUndefined(x.eSignAgreementId)) {
              x.fileName.newValue = "PCF.pdf"
            }
          })
          this.contactForm.setControl('documents', this.fb.array(this.getDocumentsGroup(contactDocList)));
        }
      }
    } else if (this.contactForm.contains('documents')) {
      this.contactForm.removeControl('documents');
    }
  }

  getDocumentsGroup(addressDocList: SupplierDocumentPropertyValues[]): FormGroup[] {
    return addressDocList.map(x => {
      return this.getDocumentGroup(x);
    });
  }

  getDocumentGroup(x: SupplierDocumentPropertyValues): FormGroup {
    return this.fb.group({
      documentId: [x.documentID.newValue, null],
      fileName: [x.fileName.newValue, !this.isPCFUploaded ? Validators.required : null],
      attachment: [null],
      documentType: [null]
    });
  }

  toShowITContactWarning() {
    if (this.contactForm.get('Types').value &&
      this.contactForm.get('Types').value.find(x => x.toLowerCase() === 'it contact')) {
      if (this.data && this.data.types && this.data.types?.newValue?.find(x => x.toLowerCase() === 'it contact')
        && this.data.iTchecking?.newValue == null) {
        this.showITcontactWarning = false;
      }
      else {
        this.showITcontactWarning = true;
      }
    }
    else {
      this.showITcontactWarning = false;
    }

    this.isITchecked = this.data?.iTchecking?.newValue == true ? true : false;
  }
  iTCheckBox(e) {
    this.isITchecked = e.source.checked;
  }

  get documents() {
    return this.contactForm.get('documents') as FormArray;
  }

  get guideLinesUrl(): string {
    return `${this.config.SRM_UI_URL}/documents`;
  }

  // custom field validations
  setHasDomainValidDomainFieldsAndValidators() {
    let hasValidDomain = this.ContactformControls.HasValidDomain.value;

    // Email validators
    this.ContactformControls.Email.clearValidators();
    this.ContactformControls.AddToValidDomain.clearValidators();

    if (hasValidDomain == "Yes") {
      this.ContactformControls.AddToValidDomain.setValue(null);
      this.ContactformControls.Email.setValidators([Validators.required, Validators.email, this.validEmailDomainValidator(this.validDomainList)]);
    } else if (hasValidDomain == "No") {
      this.ContactformControls.Email.setValidators([Validators.required, Validators.email]);
      this.ContactformControls.AddToValidDomain.setValidators([Validators.required]);
    } else {
      this.ContactformControls.AddToValidDomain.setValue(null);
      this.ContactformControls.Email.setValidators([Validators.required, Validators.email]);
    }

    this.ContactformControls.Email.updateValueAndValidity();
    this.ContactformControls.AddToValidDomain.updateValueAndValidity();
  }

  validEmailDomainValidator(validDomains: string[] | null): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const email: string = control.value;

      if (!email) {
        return null; // If no value provided, return null (validation is considered as successful)
      }

      if (!validDomains || validDomains.length === 0) {
        return { 'invalidValidDomains': { value: email } }; // Valid domains list is empty, return an error object
      }

      // Extract the domain from the email address
      const atIndex = email.indexOf("@");
      if (atIndex === -1) {
        return { 'invalidEmail': { value: email } }; // Email address is invalid, return an error object
      }
      const domain = email.substring(atIndex + 1).toLowerCase(); // Convert domain to lowercase

      // Convert all valid domains to lowercase for case-insensitive comparison
      const lowerCaseValidDomains = validDomains.map(domain => domain.toLowerCase());

      // Check if the domain is in the lowerCaseValidDomains array
      if (lowerCaseValidDomains.includes("@" + domain)) {
        return null; // Domain is valid, return null
      } else {
        return { 'invalidDomain': { value: email } }; // Domain is invalid, return an error object
      }
    };
  }
}
